import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoginHeader from "../../login/LoginHeader";
import LoginCoverImage from "../../login/LoginCoverImage";
import { rejectInvite, unsubscribe } from "store/actions/tiers";
import { success as toastSuccess, warn as toastWarn } from 'components/toast';
import Loader from "components/pages/components/loader";

const InviteDenied = (props) => {
  const {
    triggerDenyInvite,
    triggerUnsubscribe
  } = props;
  const [removeFromOutreach, setRemoveFromOutreach] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) return toastWarn('Invalid link');

    const payload = {
      token,
      onSuccess: () => {
        setIsLoading(false);
        toastSuccess('Invitation Denied');
      },
      onError: () => {
        setIsLoading(false);
        toastWarn('Error while trying to deny invite');
      }
    }

    triggerDenyInvite(payload);
  }, [])

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setError("");

    try {
      setIsLoading(true);
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (!token) return toastWarn('Invalid link');

      const payload = {
        token,
        onSuccess: () => {
          setIsLoading(false);
          setSuccess(true);
          toastSuccess('Successfully unsubscribed');
        },
        onError: () => {
          setIsLoading(false);
          toastWarn('Error while trying to unsubscribe');
        }
      }

      triggerUnsubscribe(payload);
    } catch (err) {
      setError(
        "There was an error sending your request. Please try again later."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="flex min-h-screen bg-gray-50">
        <div className="flex flex-col w-full sm:w-3/4">
          <LoginHeader />

          <div className="flex mt-16 items-center justify-center px-4">
            <div className="bg-white rounded-2xl shadow-[0_10px_25px_rgba(0,0,0,0.08),0_-2px_8px_rgba(0,0,0,0.04)] p-10 max-w-lg w-full text-center">
              {!success && (
                <>
                  <h2 className="text-2xl font-semibold text-gray-900 mb-3">
                    Your Response Received
                  </h2>

                  <p className="text-gray-600 mb-8 leading-relaxed">
                    We’ve noted that you’re not available for this event.
                    When new opportunities come up, we’ll reach out again.
                  </p>

                  <label className="flex items-start gap-[10px] text-sm text-gray-700 text-left mb-6">
                    <input
                      type="checkbox"
                      checked={removeFromOutreach}
                      onChange={(e) => setRemoveFromOutreach(e.target.checked)}
                      className="mt-0.5 h-4 w-4 rounded border-gray-300"
                    />
                    <span>
                      Remove me from future event outreach.
                      <br />
                      <span className="text-xs text-gray-500">
                        If you’d like to stop receiving emails about upcoming opportunities from The PPL Events, select this option and click Submit.
                      </span>
                    </span>
                  </label>

                  <button
                    onClick={handleSubmit}
                    disabled={isSubmitting || !removeFromOutreach}
                    className={`w-full py-2.5 rounded-lg font-medium transition border
                      ${
                        isSubmitting || !removeFromOutreach
                          ? "bg-btnDisableGray text-white border-btnDisableGray cursor-not-allowed"
                          : "bg-white text-black border-black hover:bg-black hover:text-white active:bg-black"
                      }
                    `}
                  >
                    Submit
                  </button>

                  {error && (
                    <p className="mt-4 text-sm text-[#ff0000]">
                      {error}
                    </p>
                  )}
                </>
              )}

              {success && (
                <p className="mt-6 text-sm font-medium text-[#5bb466]">
                  You’ll no longer receive emails about upcoming opportunities from The PPL Events.
                </p>
              )}
            </div>
          </div>
        </div>

        <LoginCoverImage />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  triggerDenyInvite: rejectInvite,
  triggerUnsubscribe: unsubscribe
};

export default connect(null, mapDispatchToProps)(InviteDenied);
